import { render, staticRenderFns } from "./MingyeCourse.vue?vue&type=template&id=4d8f690b&scoped=true"
import script from "./MingyeCourse.vue?vue&type=script&lang=js"
export * from "./MingyeCourse.vue?vue&type=script&lang=js"
import style0 from "./MingyeCourse.vue?vue&type=style&index=0&id=4d8f690b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f690b",
  null
  
)

export default component.exports